import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    LabelList,
} from "recharts";
import { ChartTooltip } from "../common/ChartTooltip";
import { CHART_COLORS } from "../../utils/constant";

export const StackedBarChart = ({ data, minWidth }) => (
    <ResponsiveContainer width="100%" height="100%" minWidth={minWidth}>
        <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
            barSize={50}
        >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
                dataKey="name"
                axisLine={true}
                stroke="#231F20"
                tickLine={true}
                tick={{ fontSize: 12, fill: "#231F20", fontWeight: "bold" }}
            />
            <YAxis
                axisLine={true}
                stroke="#231F20"
                tickLine={true}
                tick={{ fontSize: 12, fill: "#231F20", fontWeight: "bold" }}
            />
            <Tooltip
                content={<ChartTooltip />}
                cursor={{ fill: "transparent" }}
            />
            <Bar
                dataKey="largeCapValue"
                name="Large Cap"
                stackId="a"
                fill={CHART_COLORS.largeCap}
            >
                <LabelList
                    dataKey="largeCapValue"
                    position="inside"
                    style={{ fontWeight: "bold", color: "#231F20" }}
                    formatter={(value) => (value > 0 ? value : null)}
                />
            </Bar>
            <Bar
                dataKey="midCapValue"
                name="Mid Cap"
                stackId="a"
                fill={CHART_COLORS.midCap}
            >
                <LabelList
                    dataKey="midCapValue"
                    position="inside"
                    style={{ fontWeight: "bold", color: "#231F20" }}
                    formatter={(value) => (value > 0 ? value : null)}
                />
            </Bar>
            <Bar
                dataKey="smallCapValue"
                name="Small Cap"
                stackId="a"
                fill={CHART_COLORS.smallCap}
                radius={[10, 10, 0, 0]}
            >
                <LabelList
                    dataKey="smallCapValue"
                    position="inside"
                    style={{ fontWeight: "bold", color: "#231F20" }}
                    formatter={(value) => (value > 0 ? value : null)}
                />
            </Bar>
        </BarChart>
    </ResponsiveContainer>
);
